export default "__VITE_ASSET__lgtrNVen__"